import React from 'react';

import AutoSuggestSelect from '../../../components/common/auto-suggestion-select/Select';
import { DISPLAY_OPTIONS } from '../../../../constants/index';

const CustomPaginationItemsDisplay = ({
  pageSize,
  setPageSize,
  suffixMessage,
  prefixMessage = 'Records per page',
  hideAria = false,
}) => {
  console.log('****************************************', pageSize);
  return (
    <div className="d-flex pagination-items-container-member">
      <div
        className="d-flex align-items-center"
        aria-label={`${prefixMessage} ${pageSize}, click again to change: number of record per page.`}
      >
        <div className="pagination-prefix">
          <p>{prefixMessage}</p>
        </div>

        <div className="pagination-count">
          <AutoSuggestSelect
            onChange={setPageSize}
            options={DISPLAY_OPTIONS}
            value={{ label: pageSize, value: pageSize }}
            components={{ IndicatorSeparator: () => null }}
          />
        </div>
      </div>

      <div className="pagination-suffix" aria-hidden={hideAria}>
        <p>{suffixMessage}</p>
      </div>
    </div>
  );
};

export default CustomPaginationItemsDisplay;
